<template>
  <div
    style="display: flex; align-items: center; background: #f6f6f6; color: #fff"
  >
    <el-icon
      :size="20"
      color="#555454"
      style="margin: 0 20px"
      @click="onMenuToggle"
      class="icon-hidden"
    >
      <Expand v-if="props.hideMenu" /> <Fold v-else />
    </el-icon>
    <li
      class="header-menu"
      :class="
        $store.state.navData[$store.state.navIndex]?.path == 'HomeMain'
          ? 'header-menu-active'
          : ''
      "
      @click="$store.commit('openMenu', { path: 'HomeMain', title: '首页' })"
    >
      <el-icon size="18" style="margin-right: 5px"><House /></el-icon>
      首页
    </li>
    <li
      class="header-menu"
      :class="
        $store.state.navData[$store.state.navIndex]?.path == 'HomeSetting'
          ? 'header-menu-active'
          : ''
      "
      @click="$store.commit('openMenu', { path: 'HomeSetting', title: '设置' })"
    >
      <el-icon size="18" style="margin-right: 5px"><Setting /></el-icon>
      设置
    </li>
    <li
      class="header-menu"
      :class="
        $store.state.navData[$store.state.navIndex]?.path == 'HomeNotice'
          ? 'header-menu-active'
          : ''
      "
      @click="$store.commit('openMenu', { path: 'HomeNotice', title: '通知' })"
    >
      <el-icon size="18" style="margin-right: 5px"><ChatDotRound /></el-icon>
      通知
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          height: 20px;
          border-radius: 10px;
          background-color: #f56c6c;
          color: #fff;
          padding: 5px;
          overflow: hidden;
          font-size: 12px;
          margin-top: -10px;
        "
      >
        99+
      </div>
    </li>
    <!-- <li class="userCss">
      <el-dropdown
        type="primary"
        style="margin-left: 10px; cursor: pointer; outline: none"
      >
        <template #default>
          <div style="font-size: 13px; display: flex; align-items: center">
            <li>
              <el-icon size="17"><Avatar /></el-icon>
            </li>
            <li style="margin-left: 5px; margin-right: 20px">
              {{ $store.state.loginUser?.Xm }}<br />
              <text style="color: #a2a2a2; font-size: 12px; line-height: 16px">
                {{ $store.state.loginUser?.BmMc }}
              </text>
            </li>
          </div>
        </template>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              @click="
                $store.commit('openMenu', {
                  path: 'HomeEditInfo',
                  title: '个人信息',
                  refresh: true,
                })
              "
            >
              个人信息
            </el-dropdown-item>
            <el-dropdown-item
              @click="
                $store.commit('openMenu', {
                  path: 'HomeEditPass',
                  title: '修改密码',
                  refresh: true,
                })
              "
            >
              修改密码
            </el-dropdown-item>
            <el-dropdown-item @click="state.showPz = true">
              系统配置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </li> -->
    <ul
      style="
        display: flex;
        justify-content: flex-end;
        flex: 1;
        height: 100%;
        align-items: center;
      "
    >
      <el-dropdown style="height: 100%">
        <div
          style="
            display: flex;
            align-items: center;
            height: 100%;
            outline: none;
            cursor: pointer;
          "
        >
          <el-icon style="margin-right: 5px" size="20"><User /></el-icon>
          <text style="color: #4e4e4b; font-size: 16px">
            {{ $store.state.loginUser?.name }}
          </text>
          <text
            style="color: #4e4e4b"
            v-if="$store.state.loginUser?.department_name"
          >
            ({{ $store.state.loginUser?.department_name }})
          </text>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              @click="
                $store.commit('openMenu', {
                  path: 'HomeEditInfo',
                  title: '个人信息',
                  refresh: true,
                })
              "
              >个人信息</el-dropdown-item
            >
            <el-dropdown-item
              style="color: #f00"
              @click="
                $store.commit('openMenu', {
                  path: 'HomeEditPass',
                  title: '修改密码',
                  refresh: true,
                })
              "
              >修改密码</el-dropdown-item
            >
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <li
        class="header-logout"
        @click="onLogout"
        style="
          margin-left: 40px;
          background-color: #2441bf;
          color: #fff;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          padding: 0 20px;
        "
      >
        <el-icon :size="17" style="margin-right: 2px"><SwitchButton /></el-icon>
        退出
      </li>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import { ElLoading } from "element-plus";
export default {
  props: {
    hideMenu: Boolean,
  },
  setup(props, { emit }) {
    const router = useRouter();
    const state = reactive({});
    onMounted(() => {});

    const onLogout = () => {
      const loading = ElLoading.service({
        lock: true,
        text: "正在退出……",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        localStorage.removeItem("token");
        router.go(0);
        loading.close();
      }, 1000);
    };

    const onMenuToggle = () => {
      state.hideMenu = !state.hideMenu;
      emit("menuToggle");
    };

    return { state, onLogout, router, onMenuToggle, props };
  },
};
</script>
<style lang="less">
.icon-hidden {
  cursor: pointer;

  & > :hover {
    color: #a2a2a2;
  }
}

.header-menu {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 20px;
  font-size: 14px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.6);

  &:hover {
    color: #458df3;
  }
}

.header-menu-active {
  color: #458df3;
}

.header-logout {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 10px;
  font-size: 12px;
  cursor: pointer;
  color: #4e4e4b;

  &:hover {
    color: #27a6d8;
  }
}
</style>
